import apiPath from "../../configs/apiPath";
import { get, post } from "../../../functions/fetch/fetch";

export const downloadAllPhoneCode = async () => {
  let url = apiPath.masterData.getAllPhoneCode;
  let { status, response } = await get(url, {}, false);
  return !status ? [] : response.data;
};
